(function () {
    'use strict';

    angular.module('app.controllers')
        .controller('OverviewCtrl', OverviewCtrl)
    ;

    /* @ngInject */
    function OverviewCtrl($rootScope, DataFactory, Papa, FileSaver, Blob) {

        var vm = this;

        vm.downloadTable = downloadTable;
        vm.surfingFactsHeader = {};

        var surfingFacts = {};
        angular.forEach(['overview', 'overview2'], function (file) {

            DataFactory.getTableData(file).then(function (allData) {

                var header = allData.columns.slice(1);

                angular.forEach(allData.rows, function (row) {
                    var month = row.values[0];

                    vm.surfingFactsHeader[month] = header;

                    if (surfingFacts[month] === undefined) {
                        surfingFacts[month] = [];
                    }

                    var brandData = [];
                    for (var i = 1; i < row.values.length; i++) {
                        brandData.push(row.values[i]);
                    }
                    surfingFacts[month].push(brandData);
                });

            });
        });
        vm.surfingFacts = surfingFacts;

        DataFactory.getTableData('fact').then(function (allData) {

            var facts = {};

            angular.forEach(allData.rows, function (data) {
                facts[data.values[0]] = data.values[1]
            });

            vm.facts = facts;
        });

        function downloadTable() {
            var data = {
                fields: vm.surfingFactsHeader,
                data: []
            };

            angular.forEach(vm.surfingFacts[$rootScope.dataFilterSelected.value], function (row) {
                data.data.push(row);
            });

            var blob = new Blob([Papa.unparse(data)], {type: 'text/csv'});
            FileSaver.saveAs(blob, 'Surfing Facts ' + $rootScope.dataFilterSelected.value + '.csv');
        }
    }

})();
